import { IReduxStore } from "Redux/Store/IReduxStore";

export const getOrderCount = (state: IReduxStore) =>
    state.order.order.maxCount;